var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"custom-home-layout"},[_c('v-flex',{attrs:{"xs12":""}},[_vm._l((_vm.tags),function(tag){return [(tag.programs.length > 0)?_c('TagCarousel',{key:tag.id,attrs:{"tag":tag}}):_vm._e()]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }